import { Mark } from 'tiptap';
import { updateMark } from 'tiptap-commands';

export default class FontSize extends Mark {
  get name() {
    return 'font_size';
  }

  get schema() {
    return {
      attrs: {
        fontSize: {
          default: '16px',
        },
      },
      content: 'inline*',
      group: 'block',
      draggable: false,
      parseDOM: [{
        style: 'font-size',
        getAttrs: (mark) => ({ fontSize: mark }),
      }],
      toDOM: (mark) => ['span', { style: `font-size: ${mark.attrs.fontSize}` }, 0],
    };
  }

  commands({ type }) {
    return (attrs) => updateMark(type, attrs);
  }
}
